import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import BackOffice from "@/components/account/BackOffice";
import { PageHead, Pill, TONES } from "@/components/account/Shell";
import CouponsPanel from "@/components/account/CouponsPanel";
import SalesPanel from "@/components/account/SalesPanel";

const TONE = TONES.marketing;

/**
 * Coupons and discounts are one job: getting somebody to buy today. One window, two shelves —
 * codes the customer types, and markdowns that just happen.
 */
export default function Promotions() {
    const [params, setParams] = useSearchParams();
    const tab = params.get("tab") === "coupons" ? "coupons" : "discounts";
    const [counts, setCounts] = useState({ coupons: null, sales: null });

    return (
        <BackOffice>
            <PageHead kicker="Marketing" tone={TONE} title="Coupons & discounts" testid="promotions-head"
                sub="Everything that takes money off a bag lives here. A discount is automatic — the customer sees the sale price everywhere. A coupon is a code they type at your register." />

            <div className="mt-4 flex flex-wrap gap-1.5" data-testid="promotions-tabs">
                <Pill active={tab === "discounts"} testid="promotions-tab-discounts" count={counts.sales}
                    onClick={() => setParams({ tab: "discounts" })}>Discounts & sales</Pill>
                <Pill active={tab === "coupons"} testid="promotions-tab-coupons" count={counts.coupons}
                    onClick={() => setParams({ tab: "coupons" })}>Coupon codes</Pill>
            </div>

            <div className="mt-4">
                {tab === "coupons"
                    ? <CouponsPanel onCount={(n) => setCounts((c) => (c.coupons === n ? c : { ...c, coupons: n }))} />
                    : <SalesPanel onCount={(n) => setCounts((c) => (c.sales === n ? c : { ...c, sales: n }))} />}
            </div>
        </BackOffice>
    );
}
